module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "New Course",
      "size": "choose_options",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.selected_tab === '') ? _c('div', {
    staticClass: "px-6 pb-8"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 mb-5"
  }, [_c('button', {
    staticClass: "flex items-center space-x-4 hover:bg-primary-new_light px-4 hover:border-primary-dark py-4 rounded-md text-gray-800 font-poppins cursor-pointer border border-solid border-gray-200",
    on: {
      "click": function($event) {
        _vm.selected_tab = 'title_section'
      }
    }
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": "/static/logos/new_roundtable_icon.svg",
      "width": "23px",
      "height": "23px"
    }
  }), _vm._v(" "), _c('span', {}, [_vm._v(" From Scratch ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-4"
  }, [_c('h4', {
    staticClass: "text-base font-poppins text-gray-800"
  }, [_vm._v("Start a course from your LMS")]), _vm._v(" "), (_vm.loadingProviders) ? _c('div', {
    staticClass: "grid grid-cols-2 gap-x-2 gap-y-2"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse"
  }, [_c('div', {
    staticClass: "w-6 h-6 bg-gray-200 rounded-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 bg-gray-200 rounded w-2/3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse"
  }, [_c('div', {
    staticClass: "w-6 h-6 bg-gray-200 rounded-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 bg-gray-200 rounded w-2/3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse"
  }, [_c('div', {
    staticClass: "w-6 h-6 bg-gray-200 rounded-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 bg-gray-200 rounded w-2/3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse"
  }, [_c('div', {
    staticClass: "w-6 h-6 bg-gray-200 rounded-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 bg-gray-200 rounded w-2/3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3 px-4 py-4 rounded-md border border-solid border-gray-200 animate-pulse"
  }, [_c('div', {
    staticClass: "w-6 h-6 bg-gray-200 rounded-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 bg-gray-200 rounded w-2/3"
  })])]) : _c('div', {
    staticClass: "grid grid-cols-2 gap-x-2 gap-y-2"
  }, [_c('button', {
    staticClass: "flex items-center space-x-3 hover:bg-gray-50 px-4 hover:border-primary-dark py-4 rounded-md text-gray-800 font-poppins cursor-pointer border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.selectProvider({
          name: 'Google Classroom',
          icon_url: '/static/google_class_round.png'
        })
      }
    }
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": "/static/google_class_round.png",
      "width": "25px",
      "height": "25px"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Google Classroom ")])]), _vm._v(" "), _vm._l((_vm.providers), function(provider) {
    return _c('button', {
      key: provider.name,
      staticClass: "flex items-center space-x-3 px-4 py-4 rounded-md text-gray-800 font-poppins cursor-pointer border border-solid border-gray-200",
      class: {
        'opacity-50': !_vm.memberships.school_membership,
        'hover:bg-gray-50 hover:border-primary-dark': _vm.memberships.school_membership
      },
      on: {
        "click": function($event) {
          return _vm.selectProvider(provider)
        }
      }
    }, [_c('img', {
      staticClass: "rounded-full",
      attrs: {
        "src": ("/static/integrations/" + (provider.name) + ".png"),
        "width": "25px",
        "height": "25px"
      }
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(provider.name) + " ")])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.selected_tab === 'title_section') ? _c('div', {
    staticClass: "px-6 pb-6"
  }, [_c('div', {
    staticClass: "flex flex-col flex-grow h-full space-y-6 mb-5"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2.5"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1"
  }, [_c('label', {
    staticClass: "font-poppins text-gray-800"
  }, [_vm._v("Title "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.title),
      expression: "form_data.title"
    }],
    staticClass: "bg-gray-100 text-sm text-gray-700 flex-grow outline-none px-4 py-1.5 focus-within:border-primary w-full rounded placeholder-gray-400",
    attrs: {
      "placeholder": 'Choose a name for your course...',
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-1"
  }, [_c('label', {
    staticClass: "font-poppins text-gray-800"
  }, [_vm._v("Section")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.section),
      expression: "form_data.section"
    }],
    staticClass: "bg-gray-100 text-sm text-gray-700 flex-grow outline-none px-4 py-1.5 focus-within:border-primary border border-solid w-full rounded placeholder-gray-400",
    attrs: {
      "placeholder": "Add a section to the course...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.section)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "section", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.hasSchool) ? _c('div', {
    staticClass: "flex items-center text-sm"
  }, [_c('pl-checkbox', {
    model: {
      value: (_vm.is_school_course),
      callback: function($$v) {
        _vm.is_school_course = $$v
      },
      expression: "is_school_course"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center text-sm -ml-1.5 space-x-2"
  }, [_c('span', {
    staticClass: "font-poppins text-gray-800"
  }, [_vm._v("This is a course in my School: ")]), _vm._v(" "), _c('span', {
    staticClass: "text-sm text-gray-600"
  }, [_vm._v("\n            " + _vm._s(_vm.school.name) + "\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('h6', {
    staticClass: "text-base font-poppins text-gray-800 font-semibold"
  }, [_vm._v("Invite Teachers")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full mb-3"
  }, [_c('div', {
    staticClass: "w-full bg-gray-100 subpixel-antialiased select-none flex items-center space-x-2 text-xs text-gray-700 flex-grow outline-none px-3 py-2 mr-2 rounded"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info"
  }), _vm._v(" "), _c('p', [_vm._v("You can only invite teachers that have already signed up to Parlay *")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-full mb-3"
  }, _vm._l((_vm.co_teachers), function(co_teacher) {
    return _c('div', {
      key: co_teacher.id,
      staticClass: "w-full"
    }, [_c('div', {
      staticClass: "flex w-full justify-between bg-gray-100 rounded-lg px-4 py-2 mb-2"
    }, [_c('div', {
      staticClass: "flex items-center space-x-3"
    }, [_c('img', {
      staticClass: "w-8 h-8 rounded-full",
      attrs: {
        "src": co_teacher.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex font-poppins flex-col"
    }, [_c('span', {
      staticClass: "font-semibold text-gray-800 antialiased"
    }, [_vm._v(_vm._s(co_teacher.name))]), _vm._v(" "), _c('span', {
      staticClass: "text-xs antialiased text-gray-600 -mt-0.5"
    }, [_vm._v(_vm._s(co_teacher.email))])])]), _vm._v(" "), _c('button', {
      staticClass: "text-red-500",
      on: {
        "click": function($event) {
          return _vm.selectCoTeacherToRemove(co_teacher)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-trash-can text-sm"
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w-full flex items-center space-x-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.co_teacher_email_to_invite),
      expression: "co_teacher_email_to_invite"
    }],
    staticClass: "bg-gray-100 focus-within:border-primary text-sm text-gray-500 flex-grow outline-none px-4 py-1.5 rounded placeholder-gray-400",
    attrs: {
      "placeholder": "Enter a Parlay Teacher's Email"
    },
    domProps: {
      "value": (_vm.co_teacher_email_to_invite)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCoteacher.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.co_teacher_email_to_invite = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "flex items-center justify-center w-8 h-8 text-white transition-colors duration-150 bg-gray-500 rounded focus:shadow-outline hover:bg-gray-700",
    class: {
      isLoadingTeacher: 'bg-primary'
    },
    on: {
      "click": _vm.addCoteacher
    }
  }, [(_vm.isLoadingTeacher === true) ? _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  })])]) : _c('div', [_c('i', {
    staticClass: "fa-solid fa-plus text-base",
    staticStyle: {
      "margin-left": "1px",
      "margin-top": "-1px"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-between items-center"
  }, [_c('button', {
    staticClass: "px-4 py-1.5 border border-solid border-gray-200 rounded hover:bg-gray-100",
    on: {
      "click": function($event) {
        _vm.selected_tab = '';
        _vm.show_instructions = false;
        _vm.courses = [];
        _vm.selectedCoursesToImport = {};
      }
    }
  }, [_vm._v("\n        Back\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 flex items-center space-x-2 py-1.5 disabled:opacity-50 border-solid rounded text-white bg-primary hover:bg-primary-dark hover:border-primary-dark border border-primary",
    attrs: {
      "disabled": _vm.form_data.title === '' || _vm.creatingCourseLoader
    },
    on: {
      "click": function($event) {
        return _vm.createCourse(_vm.selected_tab)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.buttonMessage))]), _vm._v(" "), (_vm.creatingCourseLoader) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.selected_tab === 'lms') ? _c('div', {
    staticClass: "px-6 pb-4"
  }, [(_vm.show_instructions) ? _c('div', [_c('instructions-to-create-course-from-lms', {
    attrs: {
      "provider": _vm.selected_provider
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-between items-center mt-4"
  }, [_c('button', {
    staticClass: "px-4 py-1.5 border border-solid border-gray-200 rounded hover:bg-gray-100",
    on: {
      "click": function($event) {
        _vm.selected_tab = '';
        _vm.show_instructions = false;
        _vm.courses = [];
        _vm.selectedCoursesToImport = {};
      }
    }
  }, [_vm._v("\n          Back\n        ")]), _vm._v(" "), (!_vm.show_instructions) ? _c('button', {
    staticClass: "px-4 py-1.5 disabled:opacity-50 border-solid rounded text-white bg-primary hover:bg-primary-dark hover:border-primary-dark border border-primary",
    attrs: {
      "disabled": (_vm.selected_tab === 'lms' && !_vm.selectedCoursesToImport.id) || _vm.creatingCourseLoader
    },
    on: {
      "click": function($event) {
        return _vm.createCourse(_vm.selected_tab)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonMessage) + "\n        ")]) : _vm._e()])], 1) : _c('div', [_c('create-courses-from-lms', {
    attrs: {
      "provider": _vm.selected_provider,
      "courses": _vm.courses
    },
    on: {
      "selectedCourses": _vm.selectedCourses
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-between items-center mt-4"
  }, [_c('button', {
    staticClass: "px-4 py-1.5 border border-solid border-gray-200 rounded hover:bg-gray-100",
    on: {
      "click": function($event) {
        _vm.selected_tab = '';
        _vm.show_instructions = false;
        _vm.courses = [];
        _vm.selectedCoursesToImport = {};
      }
    }
  }, [_vm._v("\n          Back\n        ")]), _vm._v(" "), (!_vm.show_instructions) ? _c('button', {
    staticClass: "px-4 py-1.5 disabled:opacity-50 border-solid rounded text-white bg-primary hover:bg-primary-dark hover:border-primary-dark border border-primary",
    attrs: {
      "disabled": (_vm.selected_tab === 'lms' && !_vm.selectedCoursesToImport.id) || _vm.creatingCourseLoader
    },
    on: {
      "click": function($event) {
        return _vm.createCourse(_vm.selected_tab)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonMessage) + "\n        ")]) : _vm._e()])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6fd81f84!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/newCourseModal.vue
// module id = 2411
// module chunks = 61